// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo_class[data-v-9211baa6] {\n  max-width: 200px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: auto;\n  cursor: pointer;\n}\n.theme--dark.v-btn.v-btn--disabled[data-v-9211baa6]:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {\n  background-color: darkgrey !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
